import { useReward } from '@/contexts/reward-context';
import { useEffect, useState } from 'react';
import { SabaCoinEventRulesTypeEnum, SabaCoinRewardLevelInfo } from '@/types';
import React from 'react';

interface LevelInfoType {
	Level: number;
	LevelNameResource: string | null | undefined;
}

const SabaCoinRewardLevelRule = () => {

	const { currencyName, labels, getSabaCoinRewardLevelsInfo } = useReward();

	const levelInfoMap: Array<LevelInfoType> = [
		{
			Level: 0,
			LevelNameResource: labels?.lbl_RPReward1
		},
		{
			Level: 1,
			LevelNameResource: labels?.lbl_RPReward2
		},
		{
			Level: 2,
			LevelNameResource: labels?.lbl_RPReward3
		},
		{
			Level: 3,
			LevelNameResource: labels?.lbl_RPReward4
		},
		{
			Level: 4,
			LevelNameResource: labels?.lbl_RPReward5
		},
		{
			Level: 5,
			LevelNameResource: labels?.lbl_RPReward6
		},
		{
			Level: 6,
			LevelNameResource: labels?.lbl_RPReward7
		},
		{
			Level: 7,
			LevelNameResource: labels?.lbl_RPReward8
		},
		{
			Level: 8,
			LevelNameResource: labels?.lbl_RPReward9
		}
	]

	const [rewardLevelInfo, setRewardLevelInfo] = useState<SabaCoinRewardLevelInfo[]>();
	
	const fetchSabaCoinRewardLevels = async () => {
		if (!getSabaCoinRewardLevelsInfo) return;

		const data = await getSabaCoinRewardLevelsInfo();
		setRewardLevelInfo(data);
	}

	useEffect(() => {
		fetchSabaCoinRewardLevels();
	}, [])

	return (
		<div className="reward-terms" data-show="true">
			<div className="reward-terms__detail">
				<h3>{labels?.lbl_newturnover06}</h3>
				<div className="reward-hierarchy">
					<div className="reward-hierarchy__title">
						<div className="reward-gradient-text">{labels?.lbl_newturnover02}</div>
						{labels?.lbl_newturnover14}
					</div>
					<div className="reward-hierarchy__intro">{labels?.lbl_newturnover07}</div>
					<div className="reward-hierarchy-table">

						<div className="reward-hierarchy-table__th">{labels?.lbl_newturnover09}</div>
						<div className="reward-hierarchy-table__th">{labels?.lbl_newturnover10}</div>
						{
							levelInfoMap.map((levelInfo, index) => {
								return (
									<React.Fragment key={`coin_rewardlevel_${index}`}>
										<div className="reward-hierarchy-table__td">

											<div className="reward-badge-level" data-level={levelInfo.Level}>
												<div className="reward-badge-level__img"></div>
											</div>

											<div className={`reward-gradient-text reward-gradient-text--level-${levelInfo.Level}`}>{levelInfo.LevelNameResource}</div>
										</div>
										<div className="reward-hierarchy-table__td">
											<div className="reward-hierarchy-table__amount">
												<strong>{rewardLevelInfo?.filter(res => res.Level == levelInfo.Level)[0]?.ExchangeAmount}</strong>
												{` ${currencyName}`}
											</div>

											{
												levelInfo.Level >= 6 && <i className="reward-iconcolor-rise"></i>
											}

										</div>
									</React.Fragment>
								)
							})
						}

					</div>
				</div>
			</div>
		</div>
	)
}

const SabaCoinEventRule = () => {
	const { labels } = useReward();
	return (
		<div className="reward-terms" data-show="true">
			<div className="reward-terms__detail">
				<h3>{labels?.lbl_RPMemberR}</h3>
				<ol>
					<li>{labels?.lbl_SBCMemberR01}</li>
					<li>{labels?.lbl_SBCMemberR02}</li>
					<li>{labels?.lbl_SBCMemberR03}</li>
					<li>{labels?.lbl_SBCMemberR04}</li>
					<li>{labels?.lbl_SBCMemberR05}</li>
					<li>{labels?.lbl_SBCMemberR06}</li>
					<li>{labels?.lbl_SBCMemberR07}</li>
					<li>{labels?.lbl_SBCMemberR08}</li>
				</ol>
			</div>
			<div className="reward-terms__detail">
				<h3>{labels?.lbl_RPRR}</h3>
				<ol>
					<li>{labels?.lbl_SBCRR01}</li>
					<li>{labels?.lbl_SBCRR02}</li>
					<li>{labels?.lbl_SBCRR03}</li>
					<li>{labels?.lbl_SBCRR04}</li>
					<li>{labels?.lbl_SBCRR05}</li>
					<li>{labels?.lbl_SBCRR06}</li>
					<li>{labels?.lbl_SBCRR07}</li>
					<li>{labels?.lbl_SBCRR08}</li>
					<li>{labels?.lbl_SBCRR09}</li>
					<li>{labels?.lbl_SBCRR10}</li>
				</ol>
			</div>
		</div>)
}


export const RulesContent = ({
	initRuleType
}: {
	initRuleType: SabaCoinEventRulesTypeEnum
}) => {
	const { labels } = useReward();
	const [ruleType, setTabType] = useState(initRuleType);

	const changeTab = (tab: SabaCoinEventRulesTypeEnum) => {
		setTabType(tab);
	}


	const getRuleTypeSelect = (type: SabaCoinEventRulesTypeEnum) => {
		return ruleType === type ? 'true' : 'false';
	}

	return (
		<div className="reward-container reward-scroller reward-single-bg">

			<div className="shop-tabs">
				<div
					className="shop-tab"
					data-selected={getRuleTypeSelect(SabaCoinEventRulesTypeEnum.SabaCoinEvent)}
					onClick={() => changeTab(SabaCoinEventRulesTypeEnum.SabaCoinEvent)}
				>
					<div className="shop-tab__title">{labels?.lbl_newturnover05}</div>
				</div>

				<div
					className="shop-tab"
					data-selected={getRuleTypeSelect(SabaCoinEventRulesTypeEnum.RewardLevel)}
					onClick={() => changeTab(SabaCoinEventRulesTypeEnum.RewardLevel)}
				>
					<div className="shop-tab__title">{labels?.lbl_newturnover08}</div>
				</div>
			</div>

			{
				{
					[SabaCoinEventRulesTypeEnum.SabaCoinEvent]: SabaCoinEventRule(),
					[SabaCoinEventRulesTypeEnum.RewardLevel]: SabaCoinRewardLevelRule()
				}[ruleType]
			}
		</div>
	);
};